import { render } from "./versionManagement.vue?vue&type=template&id=4e1e099e&scoped=true"
import script from "./versionManagement.vue?vue&type=script&lang=js"
export * from "./versionManagement.vue?vue&type=script&lang=js"

import "./versionManagement.vue?vue&type=style&index=0&id=4e1e099e&lang=less&scoped=scoped"

import exportComponent from "E:\\claude_code\\healthmall\\tongue_desktop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e1e099e"]])

export default __exports__